import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Container, Row } from "react-bootstrap";
import Title from "../component/Title";
import TagManager from "react-gtm-module";
import HelmetSeo from "../component/HelmetSeo";

const CopyRights = () => {
  // Google Tag Manager Init
  useEffect(() => {
    TagManager.initialize({ gtmId: "GTM-XXXXXXX" });
  }, []);

  return (
    <Container>
      <HelmetSeo
        title="Copyright Notice | Vasthuparam - Intellectual Property Rights"
        name="description"
        content="All content on Vasthuparam is protected by copyright. Read our copyright notice to understand your rights and restrictions regarding our website content."
        relCa="canonical"
        hrefCa="https://www.vasthuparam.com/copyrights"
        relAl="alternate"
        hrefAl="https://m.www.vasthuparam.com/copyrights"
      />

      {/* <Helmet>
        <title>Copyrights | vasthuparam</title>
        <meta
          name="description"
          content="Learn about copyrights and ownership of content on YourSiteName. All programming articles and concepts are legally protected."
        />
        <meta
          name="keywords"
          content="copyright, programming articles, coding concepts, software ownership, copyright act"
        />
        <link rel="canonical" href="https://www.yoursite.com/copyrights" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Copyrights | YourSiteName" />
        <meta
          property="og:description"
          content="All articles and programming content on this site are protected under copyright laws."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.yoursite.com/copyrights" />
        <meta
          property="og:image"
          content="https://www.yoursite.com/assets/copyright-cover.jpg"
        />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Copyrights | YourSiteName" />
        <meta
          name="twitter:description"
          content="All programming content is legally protected under copyright."
        />
        <meta
          name="twitter:image"
          content="https://www.yoursite.com/assets/copyright-cover.jpg"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Copyrights | YourSiteName",
            description:
              "All programming content is legally protected under copyright laws.",
            url: "https://www.yoursite.com/copyrights",
          })}
        </script>
      {/* </Helmet>  */}

      <Title title="Copyrights" />
      <Row
        className="m-1 p-2 border"
        style={{ height: "auto", minHeight: 200 }}
      >
        <p>
          All articles and programming concepts on this site are owned by us and
          protected under the Copyright Act. Unauthorized reproduction or
          redistribution is prohibited.
        </p>
      </Row>
    </Container>
  );
};

export default CopyRights;
